import {getDocumentId} from 'utils'
import {z} from 'zod'

class ZodConfig {
    static string({min = 1, message = 'required'} = {}) {
        return z.string({message}).min(min, {message})
    }

    static stringDocument({message = 'required'} = {}) {
        return z.preprocess((value) => getDocumentId(value), z.string({message}))
    }

    static number({min, max, message = 'required'} = {}) {
        let schema = z.coerce.number({message})
        if (min !== undefined) schema = schema.min(min, {message: `min`})
        if (max !== undefined) schema = schema.max(max, {message: `max`})
        return schema
    }

    static date({message = 'required'} = {}) {
        return z.preprocess((value) => new Date(value), z.date({message}))
    }

    static boolean({message = 'required'} = {}) {
        return z.boolean({message})
    }

    static object(schema, {message = 'required'} = {}) {
        return z.object(schema, {message})
    }

    static array(schema, {min, max, message = 'required'} = {}) {
        let arraySchema = z.array(schema, {message})
        if (min !== undefined) arraySchema = arraySchema.min(min, {message: `min_array`})
        if (max !== undefined) arraySchema = arraySchema.max(max, {message: `max_array`})
        return arraySchema
    }
    static enum(values, {message = 'required'} = {}) {
        return z.enum(values, {message})
    }
}

export default ZodConfig
